<div class="support-container">
  <div class="support-header">
    <div class="header-content">
      <div class="title-section">
        <h2>Support Information</h2>
        <p>Manage support contact details and working hours</p>
      </div>

      <!-- Top Save Button -->
      <div class="top-actions">
        <cac-button [disabled]="!form.valid || isLoadingData()" (onClick)="onSubmit($event)">
          Update Support Information
        </cac-button>
      </div>
    </div>
  </div>

  <!-- Loading Progress Bar -->
  @if (isLoadingData()) {
    <mat-progress-bar mode="indeterminate" class="mb-4"></mat-progress-bar>
  }

  <div class="support-form">

    <!-- Contact Information Section -->
    <div class="contact-section">
      <h3>Contact Information</h3>

      <cac-field label="Email Address" type="email" [control]="form.controls.email" placeholder="Enter email address">
      </cac-field>

      <cac-field label="Phone Number" type="tel" [control]="form.controls.phoneNumber" placeholder="Enter phone number">
      </cac-field>

      <cac-field label="WhatsApp Number" type="tel" [control]="form.controls.whatsApp"
        placeholder="Enter WhatsApp number">
      </cac-field>
    </div>

    <!-- Address Section -->
    <div class="address-section">
      <h3>Address Information</h3>

      <cac-field label="Address (English)" type="textarea" [control]="form.controls.addressTextEnglish"
        placeholder="Enter address in English">
      </cac-field>

      <cac-field label="Address (Arabic)" type="textarea" [control]="form.controls.addressTextArabic"
        placeholder="أدخل العنوان باللغة العربية">
      </cac-field>

      <div class="coordinates-row">
        <cac-field label="Latitude" type="number" [control]="form.controls.lat" placeholder="Enter latitude"
          class="coordinate-field">
        </cac-field>

        <cac-field label="Longitude" type="number" [control]="form.controls.long" placeholder="Enter longitude"
          class="coordinate-field">
        </cac-field>
      </div>
    </div>

    <!-- Working Hours Section -->
    <div class="working-hours-section">
      <h3>Working Hours</h3>
      <div class="mb-1 font-medium">Working Hours (English)</div>
      <quill-editor dir="ltr" [formControl]="form.controls.shiftEnglish" theme="snow">
      </quill-editor>
      <div class="mt-6 mb-2 font-medium">Working Hours (Arabic)</div>
      <quill-editor class="arabic-editor" (onEditorCreated)="activateRTL($event)"
        placeholder="...أدخل النص هنا" [formControl]="form.controls.shiftArabic" theme="snow">
      </quill-editor>
    </div>

    <!-- Submit Button -->
    <div class="form-actions">
      <cac-button [disabled]="!form.valid || isLoadingData()" (onClick)="onSubmit($event)">
        Update Support Information
      </cac-button>
    </div>

  </div>
</div>
